import React, { useState } from "react";
import { Row } from "react-bootstrap";

function Istruzione() {
  // Stato per gestire se il diploma è aperto (true) o chiuso (false)
  const [showDiploma, setShowDiploma] = useState(false);

  // Immagine del diploma
  const linkImmagine = "https://i.imgur.com/KwSts2i.jpeg";

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <blockquote className="blockquote mb-0">
        <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0", marginBottom: "20px" }}>
          Titoli di Studio <img 
                  src="https://i.imgur.com/X1EHP04.gif" 
                  style={{ height: "50px"}} 
                />
        </h2>

        {/* --- STATO 1: L'immagine è CHIUSA, mostriamo il testo --- */}
        {!showDiploma && (
          <p style={{ textAlign: "left" }}>
            ●{" "}
            {/* Ho reso questo span cliccabile */}
            <span 
              className="purple" 
              onClick={() => setShowDiploma(true)}
              style={{ 
                cursor: "pointer", 
                textDecoration: "underline",
                fontWeight: "bold" 
              }}
              title="Clicca per vedere il diploma"
            >
              Diploma di Maturità (clicca per visualizzare)
            </span>
            {" "}presso l'Istituto "J. de la Torre" con valutazione 95/100.
          </p>
        )}

        {/* --- STATO 2: L'immagine è APERTA, nascondiamo il testo --- */}
        {showDiploma && (
          <div 
            onClick={() => setShowDiploma(false)} 
            style={{ cursor: "pointer", textAlign: "center", animation: "fadeIn 0.5s" }}
          >
            <img 
              src={linkImmagine} 
              alt="Diploma Maturità" 
              style={{ 
                maxWidth: "100%", 
                height: "auto", 
                borderRadius: "8px", 
                boxShadow: "0 4px 15px rgba(0,0,0,0.5)" 
              }} 
            />
            <div style={{ fontSize: "0.8rem", color: "#ccc", marginTop: "5px" }}>
              (Clicca l'immagine per chiudere)
            </div>
          </div>
        )}

      </blockquote>
    </Row>
  );
}

export default Istruzione;
